import { createContext } from 'react';
import { UserInfo } from './getUserInfo';

export type AuthUserContextType = {
  userInfo: UserInfo;
};

export const AuthUserContext = createContext<AuthUserContextType>(
  {} as AuthUserContextType,
);
